import React, {createContext, useContext} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {ChevronDownIcon} from '@heroicons/react/24/outline';
import {useAccordion} from './Accordion';

const AccordionItemContext = createContext();

export function useAccordionItem() {
  return useContext(AccordionItemContext);
}

export default function AccordionItem({id, title, icon: Icon, badge, children}) {
  const {openItems, dispatch, allowMultiple} = useAccordion();
  const isOpen = openItems.includes(id);

  const onToggle = () => {
    dispatch({type: 'TOGGLE_ITEM', payload: {id, allowMultiple}});
  };

  return (
    <div className="bg-gray-100 rounded-lg">
      <details
        open={isOpen}
        className="group [&_summary::-webkit-details-marker]:hidden">
        <summary
          className={`flex cursor-pointer items-center justify-between p-2 rounded-lg transition-colors bg-gray-100  hover:bg-gray-200 hover:border hover:border-gray-400 active:bg-gray-300`}
          onClick={(e) => {
            e.preventDefault();
            onToggle();
          }}>
          <div className="flex items-center gap-2">
            {Icon && <Icon className="h-5 w-5 text-gray-500"/>}
            <span className="text-sm font-medium text-gray-900">{title}</span>
          </div>

          <div className="flex items-center gap-2">
            <div
              className="inline-flex items-center justify-center rounded-lg bg-white px-2 py-0.5 text-xs text-gray-600 min-w-8">
              {badge || 0}
            </div>
            <motion.div
              animate={{rotate: isOpen ? 180 : 0}}
              transition={{duration: 0.2}}
              className="text-gray-500"
            >
              <ChevronDownIcon className="h-5 w-5"/>
            </motion.div>
          </div>
        </summary>

        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              initial={{height: 0, opacity: 0}}
              animate={{height: 'auto', opacity: 1}}
              exit={{height: 0, opacity: 0}}
              transition={{duration: 0.3, ease: 'easeInOut'}}
              className="overflow-hidden"
            >
              <div className="p-4 text-sm text-gray-700">
                {children}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </details>
    </div>
  );
}
